export default __webpack_public_path__ + "18478a62ed5631ea5adb3badf5633495.png";